/*! JointJS+ v3.6.1 - HTML5 Diagramming Framework

Copyright (c) 2022 client IO

 2022-10-21 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at http://jointjs.com/license/rappid_v2.txt
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import * as joint from '@clientio/rappid';

export class ToolbarService {
    
    create(commandManager, paperScroller) {
        const { tools, groups } = this.getToolbarConfig(paperScroller);
        
        this.toolbar = new joint.ui.Toolbar({
            groups,
            tools,
            autoToggle: true,
            references: {
                paperScroller: paperScroller,
                commandManager: commandManager
            }
        });
    }
    
    getToolbarConfig(paperScroller) {
        
        return {
            
            groups: {
                home: {index: 0, align: 'left'},    
                economics: { index: 1, align: 'right' },
                zoom: { index: 2, align: 'right' },
                fileoptions: { index: 3, align: 'right' },
                mbGroup: { index: 4, align: 'right' }  // Added new group for the 'mb-switch' button
            },
            tools: [
                {
                    type: 'button',
                    name: 'save-as',
                    group: 'fileoptions',
                    text: 'SA', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-save-as',
                            'data-tooltip': 'Save As',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'switch-designer',
                    group: 'home',
                    text: 'T',
                    attrs: {
                        button: {
                            id: 'btn-switch-designer',
                            'data-tooltip': 'Switch to Designer',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'home',
                    group: 'home',
                    text: 'H', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-home',
                            'data-tooltip': 'Home',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'toggle-simulate-load',
                    group: 'mbGroup',
                    text: 'S', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-toggle-simulate-load',
                            'data-tooltip': 'Toggle Simulate On Diagram Load',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'save-json',
                    group: 'fileoptions',
                    text: 'SV', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-save-json',
                            'data-tooltip': 'Save JSON',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'close-all',
                    group: 'mbGroup',
                    text: 'CA', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-close-all',
                            'data-tooltip': 'Close All Popups',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },
                { type: 'button', name: 'economics', group: 'economics', text: '$' },
                { type: 'zoom-out', name: 'zoom-out', group: 'zoom' },
                { type: 'zoom-in', name: 'zoom-in', group: 'zoom' },
                {
                    type: 'button',
                    name: 'upload',
                    group: 'fileoptions',
                    attrs: {
                        button: {
                            id: 'btn-upload',
                            'data-tooltip': 'Load JSON file',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'streamtable',
                    group: 'streamtable',
                    attrs: {
                        button: {
                            'data-tooltip': 'Export Stream Table',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'mb-switch',
                    group: 'mbGroup',
                    text: 'MB', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-mb-switch',
                            'data-tooltip': 'Switch MB',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                }
        
            ],
            references: {
                paperScroller: paperScroller // built in zoom-in/zoom-out control types require access to paperScroller instance
            }
        };
    }
}
